import React from "react";

export const UserContext = React.createContext();
export const ActionContext = React.createContext();
export const ThemeContext = React.createContext();
export const LanguageContext = React.createContext();